import React from 'react'
import styled from 'styled-components'
import contact_details_wrapperStyles from './contact_details_wrapper.styles'

const apAtomName = {ap_atom_name: 'apContactDetailsWrapperAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${contact_details_wrapperStyles}
`

const ContactDetailsWrapperAtom: React.FC = function (props) {
  return <StyledWrapper {...apAtomName} {...props} />
}

export default ContactDetailsWrapperAtom
